var map = {
	"./activities.png": 88238,
	"./cafe.png": 7063,
	"./culture.png": 12578,
	"./food.png": 38357,
	"./nature.png": 66964,
	"./nightlife.png": 16000,
	"./shopping.png": 53576,
	"./sightseeing.png": 13330,
	"./sport.png": 10642
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 31599;